'use client';

import { ReactNode } from 'react';

import { tw } from '../../utils';
import { DetailSubtitle } from './detail-subtitle';
import { DetailSupertitle } from './detail-supertitle';
import { DetailTitle } from './detail-title';

interface DetailProps {
  media: ReactNode;
  title: string;
  tier: string;
  itemType: string;
  supertitle?: string;
  titleSupplement?: ReactNode;
  content?: ReactNode;
}

export const Detail: React.FC<DetailProps> = ({
  media,
  title,
  tier,
  itemType,
  supertitle,
  titleSupplement,
  content,
}: DetailProps) => {
  return (
    <div
      className={tw(
        'relative h-full md:h-screen',
        'w-full overflow-auto p-8 md:h-full',
        'z-50 flex flex-col gap-7 bg-[#242424] pb-20 md:pb-8',
      )}
    >
      <div className={tw('relative h-[375px] w-full md:min-h-[375px]')}>
        {media}
      </div>

      <div className='flex flex-col gap-10'>
        <div className='flex'>
          <div className='flex w-full flex-col gap-0.5'>
            <div className='flex w-full justify-between'>
              <div className={tw(titleSupplement ? 'max-w-[75%]' : 'w-full')}>
                <DetailSupertitle text={supertitle} />
                <DetailTitle text={title} />
              </div>
              {titleSupplement}
            </div>
            <DetailSubtitle
              itemType={itemType}
              tier={tier}
            />
          </div>
        </div>
      </div>
      {content}
    </div>
  );
};
